<script lang="ts" setup>
const { state } = useStore();
const userInfo = computed(() => state.userInfo?.userInfo);

const clickupFormUrl = import.meta.env.VITE_APP_CLICK_UP_FORM_URL;
const env = import.meta.env.VITE_APP_ENV;
</script>

<template>
   <NxtBugReport :url="clickupFormUrl" :env="env" :user-info="userInfo" />
</template>

<style lang="scss">
.bug-report iframe {
   position: unset !important;
}
</style>
